import { SET_REFERENCE } from './../constants'

export const setReference = (reference) => ({
  type: SET_REFERENCE,
  payload: { reference }
})
